import { render, staticRenderFns } from "./TaskTypeModal.vue?vue&type=template&id=10609224&"
import script from "./TaskTypeModal.vue?vue&type=script&lang=js&"
export * from "./TaskTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10609224')) {
      api.createRecord('10609224', component.options)
    } else {
      api.reload('10609224', component.options)
    }
    module.hot.accept("./TaskTypeModal.vue?vue&type=template&id=10609224&", function () {
      api.rerender('10609224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TaskType/TaskTypeModal.vue"
export default component.exports